<script lang="ts">
    import { onMount } from "svelte";
    import {Image} from "sveltestrap";
    import {checkLayout} from "../../Data/Layout/Themecustomizer"
    import {layoutClass,selectLayoutName} from "../../store"
    import Link from "svelte-link";
    let imgPath : string= '/assets/images/landing';
    // for select layout
    const handleLayout = (getItem) => {
      layoutClass.update(value=> value = getItem.class)
    }
    onMount(() => {
      let url = window.location.href.split("=").pop();
      selectLayoutName.update((value) => (value = url));
      checkLayout.filter((item) =>
        item.class === url
          ? layoutClass.update((value) => (value = item.class))
          : ""
      );
    });
    let setLayoutClass:string;
    layoutClass.subscribe((value) => {
      setLayoutClass = value;
    });
    $: path = window.location.href.split("?").slice(0, 1);
</script>
<ul class='sidebar-type layout-grid layout-types'>
  {#each checkLayout as layoutItem }
    <li >
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <div class='layout-img'  >
        <Link href={path + `?layout=${setLayoutClass}`} on:click={()=>handleLayout(layoutItem)}>
          <Image fluid src= {`${imgPath}/demo/${layoutItem.src}`}/>
          <h6>{layoutItem.title}</h6>
        </Link>
      </div>
    </li> 
  {/each}
</ul>